import { BaseModel } from "model/BaseModel";
import ItemInspecaoFrota from "./ItemInspecaoFrota";
import { BaseEditModel } from "model/BaseEditModel";
import Veiculo from "./Veiculo";

export default class VeiculoItemInspecao implements BaseEditModel {
    id: number | null;
    codigo: string | null;
    key: string | null = null;
    sequencial: number | null = 0;
    intervaloHorasRevisao: number | null;
	intervaloQuilometragemRevisao: number | null;
	vlPeriodicidadeRevisao: number | null;
    periodicidade: String;
	horimetroUltimaInspecao: number;
	quilometragemUltimaInspecao: number;
	dataUltimaInspecao: Date | null;
    descricao: string | null;
    veiculo: Veiculo | null;
	itemInspecao: ItemInspecaoFrota;

    constructor(
        id = null,
        codigo = null,
        intervaloHorasRevisao = 0,
        intervaloQuilometragemRevisao = 0,
        vlPeriodicidadeRevisao = 0,
        periodicidade = 'DIAS',
        horimetroUltimaInspecao = 0,
        quilometragemUltimaInspecao = 0,
        dataUltimaInspecao = null,
        descricao = "",
        veiculo = null,
        itemInspecao = new ItemInspecaoFrota(),
    ) {
        this.id = id;
        this.codigo = codigo;
        this.intervaloHorasRevisao = intervaloHorasRevisao;
        this.intervaloQuilometragemRevisao = intervaloQuilometragemRevisao;
        this.vlPeriodicidadeRevisao = vlPeriodicidadeRevisao;
        this.periodicidade = periodicidade;
        this.horimetroUltimaInspecao = horimetroUltimaInspecao;
        this.quilometragemUltimaInspecao = quilometragemUltimaInspecao;
        this.dataUltimaInspecao = dataUltimaInspecao;
        this.descricao = descricao;
        this.veiculo = veiculo;
        this.itemInspecao = itemInspecao;
    }

}